import { Col, Row } from 'antd';
import { Fade } from 'react-awesome-reveal';
import { withTranslation } from 'react-i18next';
import { Button } from '../../../../common/Button';
import { SvgIcon } from '../../../../common/SvgIcon';
import { ContentBlockProps } from '../types';
import {
  ButtonWrapper,
  Content,
  ContentWrapper,
  RightBlockContainer,
} from './styles';

const RightBlock = ({
  title,
  content,
  button,
  icon,
  t,
  id,
}: ContentBlockProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: 'smooth',
    });
  };
  return (
    <RightBlockContainer>
      <Fade direction='right'>
        <Row justify='space-between' align='middle' id={id}>
          <Col lg={11} md={11} sm={11} xs={24}>
            <ContentWrapper>
              {/* THIS IS THE TITLE */}
              <h6>{t(title)}</h6>
              <Content>{t(content)}</Content>
                <a href="https://magiceden.io/marketplace/malibu_dolphin_mixer" target="_blank">
                  <Button
                    color="white"
                  >
                    {t('BUY DOLPHINS')}
                  </Button>
                </a>
                <span style={{padding: 12}}></span>
                <a href="https://discord.gg/hf2mVAXrZX" target="_blank">
                  <Button
                    color="white"
                  >
                    <span color='white'>
                      {t('JOIN DISCORD')}
                    </span>
                  </Button>
                </a>
            </ContentWrapper>
          </Col>
          <Col lg={11} md={11} sm={12} xs={24}>
            <img src={icon} width='100%' height='100%' />
            {/* <SvgIcon src={icon} width='100%' height='100%' /> */}
          </Col>
        </Row>
      </Fade>
    </RightBlockContainer>
  );
};

export default withTranslation()(RightBlock);
